import { useEffect, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Header from "../../components/header/header.component";
import Footer from "../../components/footer/footer.component";

export default function NotFound() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="d-flex flex-column flex-center flex-column-fluid p-10">
                    <img
                      src="/assets/media/illustrations/sigma-1/18.png"
                      alt=""
                      className="mw-100 mb-10 h-lg-450px"
                    />
                    <h1
                      className="fw-semibold mb-10"
                      style={{ color: "#A3A3C7" }}
                    >
                      404 - Page not found
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
